import React from 'react'
import { css } from 'aphrodite'
import { Container, Col, Row } from 'reactstrap'

import style from '../style'

export const MissionSection = props => {
  return (
    <Container>
      <Row>
        <Col xs='12' md='6'>
          <h2 className={css(style.mission.h2)}>
            Our Mission To Be{' '}
            <span className={css(style.mission.h2InnerTitle)}>The Best</span>
          </h2>
          <p className={css(style.mission.p)}>
            We constantly strive to bring you the best in-game advertising
            streams to help generate more revenue for your community.
          </p>
          <p className={css(style.mission.pSecondary)}>
            By keeping up with latest technologies and partnering up with the
            biggest and best ad providers, we can focus on bringing you the best
            game server advertisement content so that you know you're in good
            hands.
          </p>
        </Col>
        <Col xs='12' md='6'>
          <img
            src='/images/home/slide1.png'
            alt='stats'
            className={css(style.mission.image)}
          />
        </Col>
      </Row>
      <Row className={css(style.stats.wrapper)}>
        {props.stats.map((item, index) => (
          <RenderStatsBox key={index} number={item.number} desc={item.title} />
        ))}
      </Row>
    </Container>
  )
}

const RenderStatsBox = props => (
  <Col xs='12' md='3' sm='6'>
    <div className={css(style.stats.box)}>
      <span className={`d-block ${css(style.stats.number)}`}>
        {props.number}
      </span>
      <span className={`d-block ${css(style.stats.desc)}`}>{props.desc}</span>
    </div>
  </Col>
)

export default MissionSection



// WEBPACK FOOTER //
// ./src/components/Home/partials/mission.js